var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverIcon = function SvgDiscoverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.515625 1.54518V28.455C0.515625 28.7282 0.630077 28.9902 0.833801 29.1834C1.03753 29.3766 1.31384 29.4851 1.60195 29.4851H31.7365C35.7878 29.4851 39.6733 27.9594 42.5386 25.2436C45.4038 22.5278 47.0142 18.8441 47.0156 15.0027C47.0156 13.1002 46.6204 11.2163 45.8526 9.45854C45.0847 7.70083 43.9593 6.10374 42.5405 4.75844C41.1217 3.41315 39.4373 2.346 37.5836 1.61794C35.7298 0.889868 33.743 0.515137 31.7365 0.515137H1.60195C1.31384 0.515137 1.03753 0.623659 0.833801 0.816829C0.630077 1.01 0.515625 1.272 0.515625 1.54518Z",
    fill: "#EEF1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9963 11.7427H2.16797V18.1186H3.96539C4.78933 18.1644 5.60081 17.9019 6.24179 17.3822C6.60516 17.0857 6.89876 16.7127 7.10171 16.2899C7.30466 15.8671 7.41198 15.4048 7.41604 14.9358C7.41604 13.056 6.02548 11.7427 3.9963 11.7427ZM5.44866 16.5324C4.9698 16.9207 4.3577 17.1056 3.74393 17.0474H3.41432V12.8242H3.74393C4.04801 12.7934 4.35517 12.8231 4.64774 12.9115C4.9403 12.9998 5.2125 13.1452 5.44866 13.3392C5.6664 13.5421 5.84004 13.7877 5.95877 14.0606C6.0775 14.3335 6.13878 14.6279 6.13878 14.9255C6.14007 15.2264 6.07946 15.5242 5.96074 15.8007C5.84202 16.0771 5.66771 16.3262 5.44866 16.5324Z",
    fill: "#261F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22948 11.7427H7.98828V18.1186H9.22948V11.7427Z",
    fill: "#261F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2731 14.1888C11.5263 13.9159 11.31 13.7305 11.31 13.3905C11.31 13.0506 11.7014 12.6798 12.237 12.6798C12.4319 12.6834 12.6233 12.7317 12.7966 12.821C12.9698 12.9103 13.1202 13.0382 13.2362 13.1948L13.8903 12.3399C13.3744 11.8804 12.7063 11.629 12.0156 11.6343C11.7639 11.619 11.5117 11.6546 11.2741 11.7391C11.0365 11.8235 10.8183 11.955 10.6327 12.1257C10.4471 12.2964 10.2979 12.5028 10.1939 12.7325C10.0899 12.9622 10.0334 13.2106 10.0276 13.4626C10.0276 14.3382 10.4293 14.7914 11.5984 15.2086C11.8949 15.3017 12.1813 15.4242 12.4533 15.5742C12.5688 15.6409 12.6645 15.7371 12.7306 15.8529C12.7967 15.9688 12.8307 16.1001 12.8293 16.2335C12.8282 16.357 12.8018 16.479 12.7518 16.592C12.7018 16.705 12.6293 16.8066 12.5386 16.8905C12.4479 16.9744 12.341 17.0389 12.2245 17.0801C12.108 17.1212 11.9843 17.138 11.8611 17.1296C11.5772 17.1347 11.2979 17.0571 11.0574 16.9062C10.8169 16.7553 10.6255 16.5376 10.5066 16.2798L9.70312 17.0523C9.92801 17.4338 10.2512 17.7478 10.639 17.9616C11.0267 18.1754 11.4648 18.2812 11.9074 18.2678C12.192 18.2871 12.4776 18.2471 12.7459 18.1503C13.0143 18.0534 13.2596 17.9019 13.4663 17.7054C13.673 17.5088 13.8367 17.2714 13.9469 17.0083C14.0571 16.7452 14.1115 16.462 14.1066 16.1768C14.1066 15.1674 13.6894 14.709 12.2731 14.1888Z",
    fill: "#261F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5021 14.9355C14.4979 15.3771 14.5824 15.815 14.7507 16.2233C14.919 16.6316 15.1676 17.0019 15.4818 17.3122C15.7959 17.6226 16.1693 17.8666 16.5796 18.0299C16.9899 18.1931 17.4288 18.2722 17.8703 18.2626C18.409 18.2554 18.9383 18.1213 19.4154 17.8711V16.4291C19.229 16.6458 18.9984 16.82 18.7389 16.9399C18.4795 17.0599 18.1974 17.1228 17.9115 17.1244C17.6221 17.1366 17.3332 17.0877 17.0639 16.9807C16.7946 16.8738 16.5509 16.7112 16.3487 16.5037C16.1465 16.2962 15.9904 16.0483 15.8905 15.7763C15.7906 15.5043 15.7492 15.2143 15.7691 14.9252C15.758 14.6414 15.8041 14.3583 15.9044 14.0927C16.0048 13.827 16.1575 13.5842 16.3535 13.3786C16.5494 13.1731 16.7847 13.0089 17.0452 12.896C17.3058 12.783 17.5864 12.7235 17.8703 12.7209C18.1644 12.7239 18.4545 12.7897 18.721 12.9141C18.9875 13.0385 19.2243 13.2185 19.4154 13.442V11.9947C18.9427 11.7329 18.4108 11.5964 17.8703 11.5982C17.4301 11.5961 16.9937 11.6809 16.5861 11.8475C16.1785 12.0141 15.8078 12.2594 15.495 12.5693C15.1823 12.8792 14.9336 13.2476 14.7632 13.6536C14.5929 14.0596 14.5041 14.4952 14.5021 14.9355Z",
    fill: "#261F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2858 16.0277L27.5862 11.7427H26.2266L28.9304 18.2835H29.6L32.3553 11.7427H31.006L29.2858 16.0277Z",
    fill: "#261F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9141 18.1186H36.442V17.0422H34.1553V15.3221H36.3596V14.2405H34.1553V12.8242H36.442V11.7427H32.9141V18.1186Z",
    fill: "#261F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3742 13.6277C41.3742 12.4328 40.5502 11.7427 39.1133 11.7427H37.2695V18.1186H38.5107V15.5435H38.6755L40.3957 18.1186H41.9408L39.9322 15.4354C40.3563 15.3716 40.7406 15.1498 41.0081 14.8146C41.2755 14.4793 41.4063 14.0553 41.3742 13.6277ZM38.5107 14.6783V12.747H38.897C39.6695 12.747 40.0918 13.0714 40.0918 13.6946C40.0918 14.3178 39.6695 14.6783 38.8764 14.6783L38.5107 14.6783Z",
    fill: "#261F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5793 14.9252C26.5804 15.5938 26.383 16.2477 26.0121 16.8041C25.6413 17.3605 25.1137 17.7943 24.4961 18.0507C23.8785 18.307 23.1988 18.3744 22.5429 18.2442C21.8871 18.114 21.2846 17.7921 20.8118 17.3193C20.339 16.8465 20.0171 16.244 19.8869 15.5882C19.7567 14.9323 19.8241 14.2526 20.0804 13.635C20.3368 13.0175 20.7706 12.4898 21.327 12.119C21.8834 11.7482 22.5373 11.5507 23.206 11.5518C24.1002 11.5531 24.9575 11.909 25.5898 12.5413C26.2221 13.1736 26.578 14.0309 26.5793 14.9252Z",
    fill: "url(#paint0_linear_3864_47336)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    filter: "url(#filter0_i_3864_47336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5793 14.9252C26.5804 15.5938 26.383 16.2477 26.0121 16.8041C25.6413 17.3605 25.1137 17.7943 24.4961 18.0507C23.8785 18.307 23.1988 18.3744 22.5429 18.2442C21.8871 18.114 21.2846 17.7921 20.8118 17.3193C20.339 16.8465 20.0171 16.244 19.8869 15.5882C19.7567 14.9323 19.8241 14.2526 20.0804 13.635C20.3368 13.0175 20.7706 12.4898 21.327 12.119C21.8834 11.7482 22.5373 11.5507 23.206 11.5518C24.1002 11.5531 24.9575 11.909 25.5898 12.5413C26.2221 13.1736 26.578 14.0309 26.5793 14.9252Z",
    fill: "url(#paint1_linear_3864_47336)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4191 0H1.58085C1.16159 0 0.759489 0.162783 0.463021 0.452539C0.166554 0.742295 0 1.13529 0 1.54506V28.4549C0 28.8647 0.166554 29.2577 0.463021 29.5475C0.759489 29.8372 1.16159 30 1.58085 30H46.4191C46.8384 30 47.2405 29.8372 47.537 29.5475C47.8334 29.2577 48 28.8647 48 28.4549V1.54506C48 1.13529 47.8334 0.742295 47.537 0.452539C47.2405 0.162783 46.8384 0 46.4191 0ZM45.6393 15.0026C45.6379 18.844 44.0755 22.5277 41.2958 25.2435C38.5161 27.9593 34.7465 29.485 30.8161 29.485H1.58085C1.30134 29.485 1.03328 29.3765 0.835632 29.1833C0.637987 28.9901 0.526951 28.7281 0.526951 28.4549V1.54506C0.526951 1.27188 0.637987 1.00988 0.835632 0.816714C1.03328 0.623544 1.30134 0.515021 1.58085 0.515021H30.8161C32.7627 0.515021 34.6903 0.889753 36.4887 1.61782C38.2871 2.34589 39.9212 3.41303 41.2977 4.75833C42.6741 6.10362 43.766 7.70072 44.5109 9.45843C45.2558 11.2161 45.6393 13.1 45.6393 15.0026Z",
    fill: "url(#paint2_linear_3864_47336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3864_47336",
    x: 19.8223,
    y: 11.5518,
    width: 7.75781,
    height: 7.75732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3864_47336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3864_47336",
    x1: 24.9313,
    y1: 17.629,
    x2: 22.5931,
    y2: 13.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3864_47336",
    x1: 24.5605,
    y1: 17.5827,
    x2: 21.1459,
    y2: 10.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF6E00",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5A00",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF4900",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF3C00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3300",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF2D00",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF2B00",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3864_47336",
    x1: 25.2937,
    y1: -1.24333e-7,
    x2: 47.2874,
    y2: 30.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E15115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A020"
  })))));
};
export default SvgDiscoverIcon;